<template lang="html">
    <v-form ref="form" >
        <v-container grid-list-xs>
            <v-layout wrap>
                <v-flex xs12 class="table-container">
                    <v-data-table
                        :items="items"
                        :no-data-text="noData"
                        :headers="headers"
                        :loading="loading"
                        :pagination.sync="pagination"
                        :total-items="totalItems"
                        :rows-per-page-items="per_page"
                        rows-per-page-text="Eléments par page :"
                    >
                    <template slot="items" slot-scope="props">
                        <td class="text-xs-right">
                            <v-radio-group v-model="selectedIndex">
                                <v-radio :color="'primary'" :value="props.index">
                                </v-radio>
                            </v-radio-group>
                        </td>
                        <td class="text-xs-right">
                            {{props.item.label}}
                        </td>
                        <td class="text-xs-right avatar-container">
                            {{props.item.user.first_name}} {{props.item.user.last_name}}
                            le {{moment(props.item.updated_at).format('DD/MM/YYYY')}}
                            <avatar :item="props.item.user"></avatar>
                        </td>
                        <td class="text-xs-right">
                            {{props.item.requests_count}}
                        </td>
                    </template>
                </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>


<script>
import Avatar from '../../../components/avatar/Avatar.vue'
import moment from 'moment'
export default {
    components: { Avatar },
	props: {
		params: {
			required: true
		}
	},
	data() {
		return {
		    moment,
            title: 'Sélectionnez un symbole',
            supplier_product: '',
            width: '1000px',
            product_code: '',
            model: {},
            valid_button: true,
            next_button: false,
            valid_label: 'Créer à partir de ce symbole',
            selectedIndex: 0,
            loading: true,
            noData: "Chargement des symboles ... ",
            items: [],
            pagination: {
              sortBy: 'updated_at',
              rowsPerPage: 5,
              page: 1,
              descending: true
            },
            per_page:[5, 10, 20, { text: 'Tout', value: -1 }],
            totalItems: 0,
            headers: [
              { text: 'Selection', value: '', align: 'left' },
              { text: 'Label', value: 'label', align: 'right' },
              { text: 'Dernière modification', value: 'updated_at', align: 'right' },
              { text: 'Utilisations', value: 'requests_count', align: 'right' },
            ],
        }
    },
    computed: {
        pages () {
            if (this.pagination.rowsPerPage == null ||
              this.pagination.totalItems == null
            ) return 0

            return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
          }
    },
    methods: {
        onValidate() {
             let data = {
                user_id: this.$store.state.auth.user.id,
                type: 'all',
                product_id: this.params.product_id,
                symbol_id: this.items[this.selectedIndex].id,
                position: this.params.position
            };
            this.loading = true;
            this.axios.post('/api/requests',data)
                .then(response => {
                    this.loading = false;
                    this.$eventHub.$emit('close-modal2');
                    this.$eventHub.$emit('go-to-request',{id: response.data.id} );
                })
        },
        onClose() {
            this.$eventHub.$emit('close-modal2');
        },
        loadItem() {
            this.loading = 'accent'
            this.axios.get(`/api/symbols?embed=user,files,requests&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                .then(response => {
                    this.totalItems = response.data.count
                    if(response.data.data.length) {
                        this.items = response.data.data;
                        this.items.forEach((el)=>{
                            el.isSelected = false;
                        });
                        this.items[0].isSelected = true;
                        this.loading = false
                    } else {
                        this.noData = "Veuillez créer des symboles"
                        this.$eventHub.$emit('open-snackbar','warning','Il n\'y a pas de symbole dans la bibliothèque')
                        this.$eventHub.$emit('close-modal2');
                    }
                })
        }
    },
    watch: {
        pagination(){
            this.loadItem()
        }
    },
    created() {

    },
    mounted() {
        this.loadItem()
    }
}
</script>

<style lang="stylus" scoped>
    .avatar-container {
        margin-top: 30px !important
        margin-bottom: 30px !important
    }
    .checkbox-class {
        border-radius: 50% !important
        color: #479CCF !important
        border-color: #479CCF !important
    }
    .small-modal-text {
        padding-top: 0 !important
    }
</style>



// WEBPACK FOOTER //
// src/views/products/single/ImportSymbol.vue